import { SDK_ViewFile, strings } from "@quickpoint.me/shared";

function createImageUrl(map: SDK_ViewFile): string {
  const url = map.url;
  // we have old images in amazon SES, images with id are in cloudflare
  // if (map.id) {
  //   // @ts-ignore
  //   url = `https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/${map.id}/public`;
  // }
  if (!url) return strings.messages.error;
  return url;
}

export default createImageUrl;
